import { Col, Form, Input, InputNumber, Row, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal from '../../system/WebEditUniversalNewEx';
import { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import systematic from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification'
export default function BatchConversionCode(props: any) {
    const [form] = Form.useForm(); //form 
    const { data, closeModel } = props;
    const [couponData, setCouponData] = useState<any>();
    /** 后端数据defaultService */
    let defaultService: any = systematic.bmService;
    useEffect(() => {

        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    apiId: 'webCoupon',
                    apiExtend: "showList"
                }).then(res => {

                    if (res.success) {

                        setCouponData(res.data);
                    }
                });
        };
        fetchData();
    }, []);
    const handleOk = (e: any) => {
        form.validateFields()
        .then(async (values: any) => {
        
            
          fetchApi.POST(defaultService, {
            apiId: "webConversionCode",
            apiExtend: 'bulkConversionCode',
            apiData: {
              ...values,
            }
          }).then((res) => {
  
            if (res.success) {
              
                antMessage("success","成功")
                closeModel(true)
            }
          }).catch((err) => {
            antMessage("error", '错误', err);
          })
  
  
  
        })
        .catch((err) => {
  
          antMessage('warning', '无法通过数据校验', '请输入所需数据！');
        })
      
      
    };
    const handleCancel = (e: any) => {
        closeModel(false)
    };
   
    return (
        <>
            <AntDraggableModal
                title={'批量兑换券'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>


                        <Col span={12}>
                            <Form.Item
                                label="优惠券"
                                name="couponId"
                                rules={[{ required: true }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="优惠券"
                                    optionFilterProp="children"

                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(couponData, 'couponName')}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="次数"
                                name="count"
                            >
                                <InputNumber
                                    min={1}
                                />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}
